import './util/swipe-content'
import './modules/carousel/collection'
import './modules/carousel/thumbnails'
import './modules/navigation/navigation.adaptive'
import './modules/content/accordion'
import './modules/form/select'

window.Util = require('./util/util')
window.ScrollLock = require('./util/scrollLock');



// WEBPACK FOOTER //
// ./js/main.js